import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { Bonuses } from '../components/Bonuses';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { initMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-app-gradient font-sans selection:bg-[#ff006e]/30 selection:text-white overflow-x-hidden" data-id="element-99">
      <Hero data-id="element-100" />
      <SocialProof data-id="element-101" />
      <Bonuses data-id="element-102" />
      <Testimonials data-id="element-103" />
      <Guarantee data-id="element-104" />
      <FAQ data-id="element-105" />
      <FinalCTA data-id="element-106" />
      <Footer data-id="element-107" />
    </div>;
}